import React from 'react';
import Text from '@components/atomic/Text';
import { COLOR_GREEN, COLOR_RED } from '@assets/color';
import PropTypes from 'prop-types';

function FollowText({ userName, isFollow = false, handleFollow, ...props }) {
  return (
    <div {...props}>
      <Text textSize={18}>{userName}</Text>
      <Text
        textSize={14}
        textColor={isFollow ? COLOR_RED : COLOR_GREEN}
        onClick={handleFollow}
      >
        {isFollow ? ' · unfollow' : ' · follow'}
      </Text>
    </div>
  );
}

FollowText.propTypes = {
  userName: PropTypes.string,
  isFollow: PropTypes.bool,
  handleFollow: PropTypes.func,
};

export default FollowText;
